import {
  CloseOutlined,
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

import { Tag, Button } from "antd";
import { useNavigate } from "react-router-dom";

import "./ProjectDetailsPanel.css";

// Helper functions for proper text formatting
const formatStatus = (status) => {
  if (!status) return "Unidentified";
  return status
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const formatName = (name) => {
  if (!name) return "";
  return name
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

function ProjectDetailsPanel({ project, onClose }) {
  const navigate = useNavigate();

  if (!project) return null;

  const imageUrl =
    project.image ||
    project.image_url ||
    "https://media.istockphoto.com/id/1207400224/photo/high-voltage-power-line-in-a-field-at-sunset.webp?a=1&b=1&s=612x612&w=0&k=20&c=_v_oXSiIkaCeeUw0j6Zic0WOg6f1msfclD6Fu4ZUgp8=";

  const handleViewDrilldown = () => {
    if (project.id) {
      navigate(`/analytics/drilldown/${project.id}`);
    } else {
      // Fallback if ID is not directly available
      navigate(`/analytics/drilldown?id=${project.id || 9}`);
    }
  };

  return (
    <div className="project-panel">
      <div className="project-image-wrapper">
        <img
          src={imageUrl}
          alt={project.name}
          className="project-image"
        />

        <div className="project-top-line"></div>

        <button className="close-btn" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>

      <div className="project-panel-body">
        <div className="project-header">
          <div>
            <h2>{formatName(project.name || project.project_name)}</h2>

            <div className="project-location">
              <EnvironmentOutlined />
              <span>
                {project.district_name}, {project.taluka_name || project.zone_name}, {project.village || "-"}
              </span>
            </div>
          </div>

          <Tag
            color={
              project.status === "IDENTIFIED"
                ? "green"
                : project.status === "IN_PROGRESS"
                ? "blue"
                : "orange"
            }
          >
            {formatStatus(project.status || project.overall_status)}
          </Tag>
        </div>

        {/* Project Details */}
        <div className="details-card">
          <h3>Project Details</h3>

          <div className="detail-row">
            <span>Zone</span>
            <strong>{project.zone_name || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>District</span>
            <strong>{project.district_name || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Taluka</span>
            <strong>{project.taluka_name || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Village</span>
            <strong>{project.village || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Voltage</span>
            <strong>{project.voltage || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Technology</span>
            <strong>{project.technology || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Land Type</span>
            <strong>{project.land_type || "-"}</strong>
          </div>

          <div className="detail-row">
            <span>Total Area</span>
            <strong>{project.land_area_required || "-"}</strong>
          </div>
        </div>

        {/* Officer */}
        <div className="details-card">
          <h3>Assigned Officer</h3>

          <div className="info-row">
            <UserOutlined />
            <span>{project.subdivision_officer_name || project.sdo_name || "-"}</span>
          </div>

          <div className="info-row">
            <MailOutlined />
            <span>{project.sdo_email || "-"}</span>
          </div>

          <div className="info-row">
            <PhoneOutlined />
            <span>{project.sdo_contact || "-"}</span>
          </div>
        </div>

        {/* Analytics Button - Clean placement */}
        <div className="drilldown-button-container">
          <Button
            type="primary"
            icon={<BarChartOutlined />}
            onClick={handleViewDrilldown}
            block
            size="large"
            style={{ marginTop: "16px", height: "48px", fontWeight: 500 ,color: "#fff", backgroundColor: "#da241c", borderColor: "#fff" }}
          >
            View Full Drilldown Analytics
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetailsPanel;